import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { authActions } from '@/redux/modules/auth';
import logoBuilderActions from './logoBuilder.actions';
import { LogoBuilderActionTypes } from './logoBuilder.types';
import { config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import Cookies from 'js-cookie';
import { TEMPLATE_COOKIES } from '@/components/Layout/Template/Template.types';

const { WHMCS_URL } = config;

function* checkAvailability() {
  const forceUpdateJwtInReducers = Cookies.get(TEMPLATE_COOKIES.FORCE_UPDATE_JWT_IN_REDUCERS);
  if (forceUpdateJwtInReducers === 'true') {
    yield put(authActions.tokens.jwt.update());
  }

  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/logo-builder/available`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };

  yield put(logoBuilderActions.loading(true));

  try {
    const response = yield call(api.whmcs.get, request);
    const available = response && response.data && response.data.available;
    const buildingLogo = response && response.data && response.data.has_logo && !response.data.logo_sent;
    yield put(logoBuilderActions.availability.set({ available, buildingLogo }));
    yield put(logoBuilderActions.availability.success());
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas logoBuilder - method checkAvailability', error);
    yield put(logoBuilderActions.availability.failure());
  }

  yield put(logoBuilderActions.loading(false));
}

const requestLogo = function* requestLogo({ payload }) {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/logo-builder`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
    data: payload,
  };

  yield put(logoBuilderActions.loading(true));

  try {
    yield call(api.whmcs.post, request);
    yield put(logoBuilderActions.logoGeneration.success());
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas logoBuilder - method requestLogo', error);
    yield put(logoBuilderActions.logoGeneration.failure());
  }

  yield put(logoBuilderActions.loading(false));
};

function* sagas() {
  yield takeLatest(LogoBuilderActionTypes.LOGO_BUILDER_AVAILABILITY_REQUEST, checkAvailability);
  yield takeLatest(LogoBuilderActionTypes.LOGO_BUILDER_LOGO_GENERATION_REQUEST, requestLogo);
}

export default sagas;
